import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconPlay = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={className}
            fill='none'
            height='42'
            viewBox='0 0 28 28'
            width='42'
            xmlns='http://www.w3.org/2000/svg'>

            <path
                d='M11.417 18.7472L11.417 9.25391L18.731 14.0006L11.417 18.7472Z'
                fill={fill}/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconPlay;
